import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import Swal from 'sweetalert2';
import Moment from 'moment';
import 'moment/locale/es';
import { useParams } from 'react-router-dom';
import { getAuxiliares } from '../../../services/auxiliares/auxiliaresService';
import { lenguage, optionsTable, tableIcons } from "../../structure/config-datatable";

export const DatatableAuxiliares = () => {
    const { id_contador } = useParams();
    const [state, setState] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // Cargar auxiliares
    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const data = await getAuxiliares(id_contador || null);
                setState(data);
            } catch (error) {
                console.log('Error fetching auxiliares:', error);
                Swal.fire('Error', 'Error al cargar auxiliares', 'error');
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, [id_contador]);

    // Columnas de la tabla
    const columnas = [
        {
            title: "Nombre",
            field: "nombre",
            width: "25%"
        },
        {
            title: "Email",
            field: "email",
        },
        {
            title: "Contador",
            field: "contador_nombre",
        },
        {
            title: "Tipo de Membresía",
            field: "tipo_membresia",
        },
        {
            title: "Fecha Vencimiento",
            field: "fecha_vencimiento",
            render: rowData =>
                rowData.fecha_vencimiento !== undefined ?
                    Moment(rowData.fecha_vencimiento).format("D MMM YYYY")
                    : ""
        },
        {
            title: "Estado",
            field: "estado",
            width: "10%",
            render: rowData => (
                <span className="badge" style={{
                    backgroundColor: rowData.estado === 1 ? "#28a745" : "#dc3545",
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: "4px",
                    fontWeight: "bold"
                }}>
                    {rowData.estado === 1 ? "Activo" : "Inactivo"}
                </span>
            )
        }
    ];

    return (
        <>
            {!isLoading ? (
                <div className="card-body">
                    <div style={{
                        overflowX: 'auto',
                        overflowY: 'hidden',
                        marginBottom: '20px',
                        borderRadius: '4px',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)'
                    }}>
                        <MaterialTable
                            icons={tableIcons}
                            columns={columnas}
                            data={state}
                            title={""}
                            options={optionsTable}
                            localization={lenguage}
                        />
                    </div>
                </div>
            ) : (
                <div
                    className="card-body"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "400px",
                    }}
                >
                    <div className="loader-carga"></div>
                </div>
            )}
        </>
    );
};
